import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    roadmaps: [],
    concepts: [],
  },
  getters: {
    roadmap: state => slug => {
      return state.roadmaps.find(roadmap => roadmap.slug === slug);
    },
    concept: state => slug => {
      return state.concepts.find(concept => concept.slug === slug);
    },
    conceptContent: state => slug => {
      const concept = state.concepts.find(concept => concept.slug === slug);
      return concept ? concept.content : 'EMPTY_CONTENT';
    },
    conceptInTitle: state => slug => {
      const concept = state.concepts.find(concept => concept.slug === slug);
      return concept ? concept.title : 'EMPTY_CONCEPT';
    },
  },
  mutations: {
    setRoadmaps(state, roadmaps) {
      state.roadmaps = roadmaps;
    },
    setConcepts(state, concepts) {
      state.concepts = concepts;
    }
  },
  actions: {
    loadData(context) {
      // TODO replace by config
      const repoPath = 'https://api.github.com/repos/roadmap-project/dev-learning-guidelines/contents';
      const dataPath = '/database/content/out.json';

      fetch(repoPath + dataPath)
          .then(res => res.json())
          .then(data => {
            data = atob(data.content);
            data = JSON.parse(data);

            context.commit('setRoadmaps', data.roadmaps);
            context.commit('setConcepts', data.concepts);
          })
    }
  }
})
